import { createFileRoute } from "@tanstack/react-router";
import React from "react";
import { useTranslation } from "react-i18next";
import { Heading } from "src/components/base/heading";
import { Text } from "src/components/base/text";

/**
 * The properties for {@link SuccessTailscaleAuthentication}
 */
export type SuccessTailscaleAuthenticationProps = {};

/**
 * The success page for tailscale user authentication
 */
export default function SuccessTailscaleAuthentication(props: SuccessTailscaleAuthenticationProps) {
    const [t] = useTranslation("static");

    return (
        <div className={"flex flex-col items-center justify-center gap-4"}>
            <Heading>{t("heading.tailscale-success")}</Heading>
            <Text>{t("description.tailscale-success")}</Text>
        </div>
    );
}

export const Route = createFileRoute("/_static/s/tailscale-login/success")({
    component: SuccessTailscaleAuthentication,
});
